import React, { useState } from 'react';
import { NCZIElement } from '../../../../../Interfaces/ncziTypes';
import { useLazyNcziExtensionItemQuery } from '../../../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../../../helpers';
import Loading from '../../../../../../../Components/Loading';
import { NCZI_OID } from '../../../../../Enums/ncziOid.enum';

interface Props {
	element: NCZIElement | undefined;
}

function extractOidAndReference(input: string): {
	oid: string;
	reference: string;
} {
	const refPrefix = 'ref:';
	const oidIndex = input.indexOf(refPrefix);

	if (oidIndex === -1) {
		throw new Error("The input string does not contain 'ref:'.");
	}

	const parts = input.substring(oidIndex + refPrefix.length).split('/');
	if (parts.length < 2) {
		throw new Error("The input string does not contain '/'.");
	}

	return {
		oid: parts[0],
		reference: parts[1],
	};
}

const EHRElementExtension: React.FC<Props> = props => {
	const { element } = props;
	const [isReady, setIsReady] = useState<boolean>(false);
	const [referenceValue, setReferenceValue] = useState<string | null>(null);
	const [getExtensionItem] = useLazyNcziExtensionItemQuery();

	useEffectAsync(async () => {
		try {
			const { oid, reference } = extractOidAndReference(element?.value || '');
			if (
				[
					NCZI_OID.MEDICAMENTS,
					'1.3.158.00165387.100.40.60',
					NCZI_OID.HEALTH_SERVICE_PROVIDER_OUPZS,
					'1.3.158.00165387.100.40.75',
					NCZI_OID.HEALTH_SERVICE_PROVIDER,
					NCZI_OID.HEALTH_PROFESSIONAL,
				].indexOf(oid) !== -1
			) {
				const { item: extensionItem } = await getExtensionItem({
					oid,
					code: reference,
				}).unwrap();

				if (extensionItem) {
					setReferenceValue(extensionItem.name + ' (' + reference + ')');
				}
			} else {
				setReferenceValue(reference);
			}
		} catch (e) {
			console.error(e);
		}

		setIsReady(true);
	});

	if (!isReady) {
		return <Loading />;
	}

	return <>{referenceValue ?? element?.value}</>;
};

export default EHRElementExtension;
